import { render } from "./UserTile2.vue?vue&type=template&id=79377707&scoped=true"
import script from "./UserTile2.vue?vue&type=script&lang=js"
export * from "./UserTile2.vue?vue&type=script&lang=js"

import "./UserTile2.vue?vue&type=style&index=0&id=79377707&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79377707"]])

export default __exports__